import { Component, Input } from '@angular/core';
import { forkJoin } from 'rxjs';
import { DriverAttributeType } from '../../../driver/models/enums/driver-attribute-type.enum';
import { DriverMedicalCertificateDecisionType } from '../../../driver/models/enums/driver-medical-certificate-decision-type.enum';
import { DriverMedicalCertificateStatusType } from '../../../driver/models/enums/driver-medical-certificate-status-type.enum';
import { MedicalExamCertificateRestrictionType } from '../../../driver/models/enums/medical-exam-certificate-restriction-type.enum';
import { MedicalExamCertificateRestriction } from '../../../driver/models/requirement/medical-exam-certificate-restriction.model';
import { MedicalExamCertificateViewModel } from '../../../driver/models/requirement/medical-exam-certificate-view.model';
import { Jurisdiction } from '../../../foundation/models/enums/Jurisdiction.enum';
import { MedicalCertificateRestrictionTypeDriverAttributeTypeMap } from '../../models/medical-exam-certificate-restriction-type-driver-attribute-type-map.model';
import { MedicalReviewService } from '../../services/medical-review.service';

@Component({
    selector: 'historical-customer-mrp-certificates',
    templateUrl: './historical-customer-mrp-certificates.html',
    inputs: ['customerNumberId', 'topOfStackId']
})
export class HistoricalCustomerMrpCertificatesComponent {
    @Input() public customerNumberId: number;
    @Input() public topOfStackId: number;
    public medicalExamCertificateHistory: MedicalExamCertificateViewModel[];
    private signedDate: Date = new Date();
    private restrictionTypeEnum: MedicalExamCertificateRestrictionType = new MedicalExamCertificateRestrictionType();
    private driverMedicalCertificateStatusTypeEnum = new DriverMedicalCertificateStatusType();
    private jurisdictionTypeEnum: Jurisdiction = new Jurisdiction();
    private decisionTypeEnum: DriverMedicalCertificateDecisionType = new DriverMedicalCertificateDecisionType();
    private driverAttributeTypeEnum = new DriverAttributeType();
    private medicalCertificateRestrictionTypeDriverAttributeTypeMaps: MedicalCertificateRestrictionTypeDriverAttributeTypeMap[] = [];

    constructor(
        private medicalReviewService: MedicalReviewService
    ) {
        this.signedDate.setFullYear(this.signedDate.getFullYear() - 2);
    }

    ngOnInit() {
        forkJoin(this.medicalReviewService.getMedicalExamCertificateHistory(this.customerNumberId), this.medicalReviewService.getDriverMedicalCertificateRestrictionTypeDriverAttributeTypeMap())
            .subscribe(([certs, maps]) => this.prepareCerts(certs.result, maps));
    }

    private prepareCerts = (certificates: MedicalExamCertificateViewModel[], maps: any): void => {
        this.medicalCertificateRestrictionTypeDriverAttributeTypeMaps = maps.result;
        let eligibility = false;

        this.medicalExamCertificateHistory = certificates
            .filter(item =>
                (item.driverMedicalCertificateStatusTypeId == this.driverMedicalCertificateStatusTypeEnum.Voided.id ||
                 item.driverMedicalCertificateStatusTypeId == this.driverMedicalCertificateStatusTypeEnum.Rescinded.id ||
                 item.driverMedicalCertificateStatusTypeId == this.driverMedicalCertificateStatusTypeEnum.Active.id) &&
                (item.id != this.topOfStackId));

        certificates?.forEach(item => {
            item.jurisdictionDisplayValue = this.jurisdictionTypeEnum.FromId(item.medicalExamCertificateIssuingJurisdictionId)?.displayValue ?? '';
            item.decisionDisplayValue = this.decisionTypeEnum.FromId(item.medicalExamCertificateDecisionTypeId)?.displayValue ?? '';
            item.driverMedicalCertificateStatusTypeDisplayValue = this.driverMedicalCertificateStatusTypeEnum.FromId(item.driverMedicalCertificateStatusTypeId)?.displayValue ?? '';
            this.loadRestrictionDisplayValues(item, item.restrictions);

            if (item.medicalExamCertificateSignatureDate > this.signedDate) {
                eligibility = true;
            }
        });

    };

    private loadRestrictionDisplayValues = (cert: MedicalExamCertificateViewModel, restrictions: MedicalExamCertificateRestriction[]): void => {
        const restrictionValues: string[] = [];
        const restrictionCodeValues: string[] = [];

        restrictions?.forEach(e => {
            const restrictionDisplayValue = this.restrictionTypeEnum.FromId(e.restrictionTypeId)?.displayValue;

            if (restrictionDisplayValue != null) {
                restrictionValues.push(restrictionDisplayValue);
            }

            const attributeTypeId = this.medicalCertificateRestrictionTypeDriverAttributeTypeMaps
                .find(m => m.driverMedicalCertificateRestrictionTypeId === e.restrictionTypeId)?.driverAttributeTypeId;

            if (attributeTypeId != null) {
                const attribute = this.driverAttributeTypeEnum.FromId(attributeTypeId);
                restrictionCodeValues.push(attribute.driverAttributeValue);
            }
        });

        cert.restrictionCodesDisplayValues = restrictionCodeValues.join(',');
        cert.restrictionDisplayValues = restrictionValues.join(',');
    };
}
